import { useBrand } from "../context/BrandContext";

const BRAND_LOGOS = {
    hoshizora: {
        type: "image",
        src: "https://customer-assets-wrfwihn1.emergentagent.net/job_jewelry-hub-198/artifacts/e39b392c72fa5738_56F3A412-4352-4047-80A1-25129E892630.webp",
        alt: "Hoshizora",
    },
    // Add image src when uploaded. Until then, render a wordmark placeholder.
    heelsandtea: {
        type: "image",
        src: "https://customer-assets-wrfwihn1.emergentagent.net/job_jewelry-hub-198/artifacts/58707897c98247bb_3E685BAE-22BD-415A-9830-E8653C07DDFA.webp",
        alt: "Heels & Tea",
    },
};

export default function Logo({ height = 40, className = "", brand: brandProp }) {
    const { current } = useBrand();
    const brand = brandProp || current || "hoshizora";
    const cfg = BRAND_LOGOS[brand] || BRAND_LOGOS.hoshizora;

    if (cfg.type === "image") {
        return (
            <img
                src={cfg.src}
                alt={cfg.alt}
                style={{ height }}
                className={`w-auto object-contain select-none [mix-blend-mode:multiply] ${className}`}
                draggable={false}
                data-testid={`brand-logo-${brand}`}
                loading="eager"
            />
        );
    }

    // Wordmark fallback — editorial serif, brand-tinted
    return (
        <span
            style={{ height, lineHeight: `${height}px`, color: cfg.accent }}
            className={`font-serif tracking-tight select-none inline-flex items-center ${className}`}
            data-testid={`brand-logo-${brand}`}
            aria-label={cfg.label}
        >
            <span style={{ fontSize: Math.round(height * 0.7) }}>{cfg.label}</span>
        </span>
    );
}
